<div class="wrapper wrapper-content">
  <div class="container-fluid" role="region" aria-labelledby="libraryOrganismsDemoTitle">
    <div class="row">
      <div class="col-11 mt-2">
        <!---------------------------------------- Comparators ---------------------------------------->
        <!-- 001 -->
        <ui-library-section
          [config]="{
            sectionId: 'comparatorSection',
            title: organismsDictionary.comparators.title,
            panelTitle: organismsDictionary.comparators.panels.panel001.title,
            code: organismsDictionary.comparators.panels.panel001.code,
            collapsed: collapsed()
          }"
        >
          <plyca-ui-comparator-demo />
        </ui-library-section>
        <!---------------------------------------- Filters ---------------------------------------->
        <!-- 001 -->
        <ui-library-section
          [config]="{
            sectionId: 'filterGenericSection',
            title: organismsDictionary.filters.title,
            panelTitle: organismsDictionary.filters.panels.panel001.title,
            code: organismsDictionary.filters.panels.panel001.code,
            collapsed: collapsed()
          }"
        >
          <plyca-ui-button-generic class="d-flex justify-content-center mt-3" [config]="{ buttonClass: 'btn btn-xs btn-primary', type: 'button' }" (clickEvent)="openModalFilterGenericOne()">
            <span> {{ 'Open Modal' }} &nbsp; <i class="fa fa-external-link" aria-hidden="true"></i></span>
          </plyca-ui-button-generic>
        </ui-library-section>
        <!-- 002 -->
        <ui-library-section
          [config]="{
            sectionId: 'filterGenericWithSubheaderSection',
            panelTitle: organismsDictionary.filters.panels.panel002.title,
            code: organismsDictionary.filters.panels.panel002.code,
            collapsed: collapsed()
          }"
        >
          <plyca-ui-button-generic class="d-flex justify-content-center mt-3" [config]="{ buttonClass: 'btn btn-xs btn-primary', type: 'button' }" (clickEvent)="openModalFilterGenericTwo()">
            <span> {{ 'Open Modal' }} &nbsp; <i class="fa fa-external-link" aria-hidden="true"></i></span>
          </plyca-ui-button-generic>
        </ui-library-section>
        <!-- 003 -->
        <ui-library-section
          [config]="{
            sectionId: 'filterPanelSection',
            panelTitle: organismsDictionary.filters.panels.panel003.title,
            code: organismsDictionary.filters.panels.panel003.code,
            collapsed: collapsed()
          }"
        >
          <plyca-ui-filter-panel-demo />
        </ui-library-section>
        <!---------------------------------------- Forms ---------------------------------------->
        <!-- 001 -->
        <ui-library-section
          [config]="{
            sectionId: 'formsInputTextSection',
            title: organismsDictionary.forms.title,
            panelTitle: organismsDictionary.forms.panels.panel001.title,
            code: organismsDictionary.forms.panels.panel001.code,
            collapsed: collapsed()
          }"
        >
          <plyca-ui-input-text-demo />
        </ui-library-section>
        <!-- 002 -->
        <ui-library-section
          [config]="{
            sectionId: 'formsCheckboxSection',
            panelTitle: organismsDictionary.forms.panels.panel002.title,
            code: organismsDictionary.forms.panels.panel002.code,
            collapsed: collapsed()
          }"
        >
          <plyca-ui-checkbox-demo />
        </ui-library-section>
        <!---------------------------------------- Panels ---------------------------------------->
        <!-- 001 -->
        <ui-library-section
          [config]="{
            sectionId: 'collapsablePanelSection',
            title: organismsDictionary.panels.title,
            panelTitle: organismsDictionary.panels.panels.panel001.title,
            code: organismsDictionary.panels.panels.panel001.code,
            collapsed: collapsed()
          }"
        >
          <plyca-ui-collapsable-panel-demo />
        </ui-library-section>
        <!-- 002 -->
        <ui-library-section
          [config]="{
            sectionId: 'panelSection',
            panelTitle: organismsDictionary.panels.panels.panel002.title,
            code: organismsDictionary.panels.panels.panel002.code,
            collapsed: collapsed()
          }"
        >
          <plyca-ui-panel-demo />
        </ui-library-section>
        <!-- 003 -->
        <ui-library-section
          [config]="{
            sectionId: 'scrollPanelSection',
            panelTitle: organismsDictionary.panels.panels.panel003.title,
            code: organismsDictionary.panels.panels.panel003.code,
            collapsed: collapsed()
          }"
        >
          <plyca-ui-button-generic class="d-flex justify-content-center mt-3" [config]="{ buttonClass: 'btn btn-xs btn-primary', type: 'button' }" (clickEvent)="openModalScrollPanel()">
            <span> {{ 'Open Modal' }} &nbsp; <i class="fa fa-external-link" aria-hidden="true"></i></span>
          </plyca-ui-button-generic>
        </ui-library-section>
        <!---------------------------------------- Tables ---------------------------------------->
        <!-- 001 -->
        <ui-library-section
          [config]="{
            sectionId: 'TableSection',
            title: organismsDictionary.tables.title,
            panelTitle: organismsDictionary.tables.panels.panel001.title,
            code: organismsDictionary.tables.panels.panel001.code,
            collapsed: collapsed()
          }"
        >
          <plyca-ui-table-demo />
        </ui-library-section>
        <!---------------------------------------- Tabs  ---------------------------------------->
        <!-- 001 -->
        <ui-library-section
          [config]="{
            sectionId: 'TableSection',
            title: organismsDictionary.tabs.title,
            panelTitle: organismsDictionary.tabs.panels.panel001.title,
            code: organismsDictionary.tabs.panels.panel001.code,
            collapsed: collapsed()
          }"
        >
          <plyca-ui-tabs-demo />
        </ui-library-section>
        <!---------------------------------------- Trees ---------------------------------------->
        <!-- 001 -->
        <ui-library-section
          [config]="{
            sectionId: 'TableSection',
            title: organismsDictionary.tree.title,
            panelTitle: organismsDictionary.tree.panels.panel001.title,
            code: organismsDictionary.tree.panels.panel001.code,
            collapsed: collapsed()
          }"
        >
          <plyca-ui-tree-demo />
          <p class="mt-1 pl-2">See more information: <strong>product-maintenance-tree.component.ts</strong></p>
        </ui-library-section>
        <!---------------------------------------- Splitters ---------------------------------------->
        <!-- 001 -->
        <ui-library-section
          [config]="{
            sectionId: 'SplittersSection',
            title: organismsDictionary.splitters.title,
            panelTitle: organismsDictionary.splitters.panels.panel001.title,
            code: organismsDictionary.splitters.panels.panel001.code,
            collapsed: collapsed()
          }"
        >
          <plyca-ui-splitter-demo />
        </ui-library-section>
        <!---------------------------------------- Banners ---------------------------------------->
        <!-- 001 -->
        <ui-library-section
          [config]="{
            sectionId: 'BannersSection',
            title: organismsDictionary.banners.title,
            panelTitle: organismsDictionary.banners.panels.panel001.title,
            code: organismsDictionary.banners.panels.panel001.code,
            collapsed: collapsed()
          }"
        >
          <plyca-ui-banner-generic-demo />
        </ui-library-section>
      </div>
    </div>
  </div>
</div>
